import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import App from './App';
import WineList from './Components/WineList';
import WineListVinoteca from './Components/Vinotecas/WineListVinoteca';
import WineMarketplace from './Components/WineMarketplace'; // Added import

function Main() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Navigate to="/marketplace" replace />} exact />
                <Route path="/home" element={<App />} exact />
                <Route path="/list" element={<WineList />} exact />
                <Route path="/vinotecas" element={<WineListVinoteca />} exact />
                <Route path="/marketplace" element={<WineMarketplace />} exact /> {/* Added route */}
            </Routes>
        </Router>
    );
}

export default Main;